<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
  >
    <main class="mt-2 w-full">
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Jenis Transaksi</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="jenisTransaksis"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="transaction type"
          label="name"
          v-model="formData.jenis_id"
          placeholder="Pilih Jenis Transaksi"
        />
        <span class="text-danger text-sm">{{ errors.first("transaction type") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Kategori Penyaluran</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="kategoriList"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="distribution category"
          label="name"
          v-model="kategori"
          placeholder="Pilih Kategori Penyaluran"
        />
        <span class="text-danger text-sm">{{
          errors.first("distribution category")
        }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Sub-Kategori Penyaluran</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="subKategoriList"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="distribution sub-category"
          :disabled="kategori === null"
          label="name"
          v-model="formData.sub_id"
          placeholder="Pilih Sub-Kategori Penyaluran"
        />
        <span class="text-danger text-sm">{{
          errors.first("distribution sub-category")
        }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>User Tujuan</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="userList"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="user"
          label="name"
          v-model="formData.user_id"
          placeholder="Pilih User Tujuan"
        />
        <span class="text-danger text-sm">{{ errors.first("user") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Nominal Penyaluran</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          @keypress="onlyNumber"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="payment nominal"
          class="w-full sidebar-input"
          v-model="jumlah_pembayaran"
          placeholder="Isi Dengan Nominal Penyaluran"
        />
        <span class="text-danger text-sm">{{ errors.first("payment nominal") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Deskripsi</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-textarea
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="description"
          class="w-full sidebar-input"
          v-model="formData.deskripsi"
          placeholder="Isi Dengan Deskripsi Penyaluran"
        />
        <span class="text-danger text-sm">{{ errors.first("description") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Status Pembayaran</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="statusList"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="payment status"
          label="text"
          v-model="formData.status"
          placeholder="Pilih Status Pembayaran"
        />
        <span class="text-danger text-sm">{{ errors.first("payment status") }}</span>
      </div>
    </main>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl" @click="closeWithLoad(false)"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="ml-2 rounded-2xl"
          :disabled="!validateForm"
          @click="addData"
          >{{ labelButton }}</vs-button
        >
      </div>
    </footer>
  </vs-popup>
</template>
<script>
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { mapGetters } from "vuex";

export default {
  props: {
    userList: [],
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  components: {
    mapGetters,
    VuePhoneNumberInput,
  },
  data() {
    return {
      statusList: [
        {
          id: 1,
          text: "Dibayar",
        },
        {
          id: 2,
          text: "Belum Dibayar",
        },
      ],
      kategori: null,
      subKategoriList: [],
      jumlah_pembayaran: null,
      formData: {
        jenis_id: null,
        user_id: null,
        status: null,
        sub_id: null,
        deskripsi: "",
      },
    };
  },
  computed: {
    jenisTransaksis() {
      return this.$store.state.transaksi.jenisList;
    },
    kategoriList() {
      return this.$store.state.penyaluran.kategoriList;
    },
    titlePopUp() {
      return this.passData != null ? "Edit Penyaluran" : "Tambah Penyaluran";
    },
    labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.formData.jenis_id !== null &&
        this.formData.user_id !== null &&
        this.formData.status !== null &&
        this.formData.sub_id !== null &&
        this.formData.deskripsi !== "" &&
        this.jumlah_pembayaran !== null
      );
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
  },
  watch: {
    kategori() {
      if (this.kategori !== null) {
        this.subKategoriList = this.$store.getters["penyaluran/filterSubKat"](
          this.kategori
        );

        if (this.formData.sub_id !== null) {
          if (
            this.subKategoriList.find((v) => v.id === this.formData.sub_id) === undefined
          ) {
            this.formData.sub_id = null;
          }
        }
      } else {
        this.formData.sub_id = null;
      }
    },
    activate() {
      if (this.passData !== null) {
        this.formData.jenis_id = this.passData.jenis_transaksi
          ? this.passData.jenis_transaksi.id
          : null;
        this.formData.user_id = this.passData.user ? this.passData.user.id : null;
        this.formData.status = this.passData.status;
        this.formData.sub_id = this.passData.sub_id;
        this.formData.deskripsi = this.passData.deskripsi;
        this.jumlah_pembayaran = this.passData.jumlah_pembayaran;
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      this.formData.jenis_id = null;
      this.formData.user_id = null;
      this.formData.status = null;
      this.formData.sub_id = null;
      this.formData.deskripsi = "";
      this.jumlah_pembayaran = null;
      this.kategori = null;
    },
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    addData() {
      let id = {};

      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }
      this.$store
        .dispatch("penyaluran/cudPenyaluran", [
          {
            ...this.formData,
            ...id,
            jumlah_pembayaran: parseFloat(this.jumlah_pembayaran),
          },
        ])
        .then((v) => {
          this.$vs.notify({
            position: "top-right",
            title:
              this.passData !== null ? "Edit SOS Penyaluran!" : "Tambah SOS Penyaluran!",
            text:
              this.passData !== null
                ? `Penyaluran ke ${v.user.name} Berhasil diedit`
                : `Penyaluran ke ${v.user.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });

          this.closeWithLoad(true);
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            console.error(e);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: "Terjadi kesalahan, silahkan periksa jaringan anda",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.$vs.loading.close();
          this.resetForm();
        });
    },
  },
};
</script>
